import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import DemoPopup from "../demopopup"; // 👈 import popup
const tabsmob = [
  {
    id: "sf",
    label: "Seamless & Faster",
    img: "/assets/images/kwikwoocomm/s-and-m-mob.png",
  },
  {
    id: "advdis",
    label: "Advanced Discounts",
    img: "/assets/images/kwikwoocomm/discount-mob.png",
  },
  {
    id: "rtofear",
    label: "COD without RTO fears",
    img: "/assets/images/kwikwoocomm/rto-mob.png",
  },
  {
    id: "abtest",
    label: "A/B test to optimize",
    img: "/assets/images/kwikwoocomm/abtest-mob.png",
  },
];

const SectionFive = () => {
  const [activeTab, setActiveTab] = useState(tabsmob[0].id); // default to first tab
  const sectionRefs = useRef({});
  const containerRef = useRef<HTMLDivElement>(null);
  const tabsRef = useRef(null);
    const [showPopup, setShowPopup] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div>
      <div className="section-five-checkout">
        <div className="container-fluid">
          <div
            style={{
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h1 style={{ maxWidth: "500px" }}>
              A Growth Engine Your Shopify Store is Missing
            </h1>
          </div>
          {isMobile ? (
            <div>
              <div className="btn-section-five-mob" ref={tabsRef}>
                {tabsmob.map((tab) => (
                  <div
                    id={`tab-${tab.id}`}
                    key={tab.id}
                    className={`card-btn-mob-five ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.id)} // set active tab
                  >
                    {tab.label}
                  </div>
                ))}
              </div>

              <div className="sect-5-cards-mob" ref={containerRef}>
                {tabsmob
                  .filter((tab) => tab.id === activeTab) // only show selected tab
                  .map((tab) => (
                    <div key={tab.id} className="card-img-mob active">
                      <img src={tab.img} alt={tab.label} />
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="card-scroll one">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame1-check.png"
                  alt=""
                />
              </div>
              <div className="card-scroll two">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame2-check.png"
                  alt=""
                />
              </div>
              <div className="card-scroll three">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame3-check.png"
                  alt=""
                />
              </div>
              <div className="card-scroll four">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame4-check.png"
                  alt=""
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="section-5a-checkout">
        <div className="container-fluid">
          <div
            className="flex align-items-center sect-5"
            style={{
              justifyContent: isMobile ? "center" : "space-between",
              gap: "30px",
              margin: isMobile ? "0 0.2rem" : "0 5rem",
            }}
          >
            <div
              className="mid-text1-checkout"
              style={{ justifyContent: "left" }}
            >
              <h1>Go live in Minutes!</h1>
              <p
                style={{
                  justifyContent: "left",
                  display: "flex",
                  color: "#0012B7",
                }}
              >
                Maximise prepaid conversions & reduce RTOs
              </p>
            </div>

            <div>
              <button
                className="cta3-checkout"
                onClick={() => setShowPopup(true)}
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>
      </div>
        <DemoPopup show={showPopup} onClose={() => setShowPopup(false)} />
    </div>
  );
};

export default SectionFive;
